import BaseView from '../../BaseView';
import FormUtil from '../helpers/FormUtil';
export default BaseView.extend({
  el: '<span class="o-form-toggle" data-type="header-btn"></span>',

  formTitle: '',

  modelEvents: {
    'change:__edit__': 'toggle'
  },

  initialize: function () {
    this.addButton();
  },

  addButton: function () {
    if (this.model.get('__edit__')) {
      this.add(FormUtil.createReadFormButton({ type: 'cancel' }));
    } else {
      this.add(
        FormUtil.createReadFormButton({
          type: 'edit',
          formTitle: this.formTitle
        })
      );
    }
  },

  toggle: function () {
    this.removeChildren();
    this.addButton();
  }
});



// WEBPACK FOOTER //
// /Users/aarongranick/okta/okta-ui/packages/courage/src/views/forms/components/ReadModeBar.js


// WEBPACK FOOTER //
// webpack:///Users/aarongranick/okta/okta-ui/packages/courage/src/views/forms/components/ReadModeBar.js